import { fetchAuthSession } from "aws-amplify/auth";
import { AUTH_HEADER_NAME } from "../../constants";
import { logMessage } from "../../utils/amplifyLogger";

export interface JwtTokenResult {
  headers: Record<string, string>;
}

export const jwtToken = async (): Promise<JwtTokenResult | undefined> => {
  try {
    const session = await fetchAuthSession();
    if (!session) {
      throw new Error(`Something went wrong in Session`);
    }

    const { tokens: { idToken } = {} } = session;
    if (!idToken) {
      throw new Error(`idToken is undefined`);
    }
    return {
      headers: {
        [AUTH_HEADER_NAME]: idToken.toString(),
      },
    };
  } catch (err) {
    logMessage(
      `JWT Token`,
      `Could not get the jwt token due to error => ${err}`,
      `error`,
    );
    return undefined;
  }
};
